/**
 * Decide whether the team can use a bullet at all.
 *
 * A bullet lists in bullet_metadata.required_metrics the GPS metrics it can work
 * from. The team needs at least one of them, so a two-key list means either
 * metric will do. A bullet that lists nothing works for every team.
 *
 * required_metrics is edited through the admin panel rather than through code
 * review, so anything that is not a non-empty array disables no bullet.
 *
 * @param {object} bullet - A bullet from the bullet picker payload.
 * @param {string[]} gpsMetricKeys - The metric keys assigned to the team.
 * @returns {boolean} True when the team has none of the required metrics.
 */
export function isBulletDisabled(bullet, gpsMetricKeys) {
  const requiredMetrics = bullet?.bullet_metadata?.required_metrics;

  if (!Array.isArray(requiredMetrics) || requiredMetrics.length === 0) {
    return false;
  }

  const teamMetricKeys = Array.isArray(gpsMetricKeys) ? gpsMetricKeys : [];
  return !requiredMetrics.some((key) => teamMetricKeys.includes(key));
}
